import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular';
import {
  BlockReleaseHandler,
  BlockReleaseRequest,
  BlockReleaseResult,
} from '@libs/util-services';
import { firstValueFrom } from 'rxjs';
import { BlockPeriodService } from './block-period.service';

/**
 * Implementação concreta do BLOCK_RELEASE_HANDLER da calendar-lib (provido na
 * rota /agenda). Chama o release-slot e dá o feedback via toast — quem
 * recarrega a agenda é o court-event, a partir do `released: true`.
 */
@Injectable({ providedIn: 'root' })
export class LessorBlockReleaseHandler implements BlockReleaseHandler {
  private readonly blockPeriodService = inject(BlockPeriodService);
  private readonly toastController = inject(ToastController);

  async release(request: BlockReleaseRequest): Promise<BlockReleaseResult> {
    try {
      await firstValueFrom(
        this.blockPeriodService.releaseSlot(request.blockId, {
          courtId: request.courtId,
          date: request.date,
          start: request.start,
          end: request.end,
        })
      );
      await this.presentToast(
        `Horário ${request.start}–${request.end} liberado.`,
        'success'
      );
      return { released: true };
    } catch (error: any) {
      const message =
        error?.error?.message ??
        'Não foi possível liberar o horário. Tente novamente.';
      await this.presentToast(message, 'danger');
      return { released: false };
    }
  }

  private async presentToast(message: string, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 2500,
      position: 'bottom',
      color,
    });
    await toast.present();
  }
}
